import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-span-1 px-6 text-sm py-4 text-gray-200 items-center rounded"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Body',
  props: {
  round: Boolean,
  showEmpty: Boolean
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["grid grid-cols-1", {
      'rounded-lg overflow-hidden': __props.round,
      'h-full': __props.showEmpty
    }])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (__props.showEmpty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "empty")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})